module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4BAMAAABaqCYtAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUdwTC07UDJu/zBu/y5avjNv/y08UDJv/zJv/zBw/yw8UCw8UC08UDNv/3gccC8AAAAMdFJOUwBwYz0gru/jhBCQgGB9h7gAAACnSURBVDjLY2AYhGDbGSA4iODLgPhZEDbXGWySZzaA2WxHsBnnkwCmeA5gk4SKjhRJRgFskthFyQAcN0BkbwNWSdu7BgwMzHcvY5XUBUky4ZCce9eBgYHz7hWsksxBINJUAaskJ5icwDA0AEcpyJ/huILvqrJROI4Qmn4XDEqwSrLEguQqcIQCi2rt9SCqhRDeBDaaBQkVUtzYi7cFEM4ybJLZgzElAwCEy2OFjKQyrAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/pssytem2.png
// module id = xSCB
// module chunks = 0